module.exports = __webpack_public_path__ + "static/media/uniswapDark.73fe8667.png";